module.exports = __webpack_public_path__ + "static/media/justsoitalian.1954b8d3.jpg";